/**
 * @file 模型选型条件
 * @author WanZhongYun(wanzhongyun@baidu.com)
 */

import { Select, Form, Row, Col, Input, Button, Upload, Checkbox, Popover, Modal } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import { modelParams, dataAnalyze, datasetArr, statementDesc } from './../../constants';
import { ReactComponent as UploadFileSvg } from './../../images/upload_file.svg';
import { ReactComponent as UploadDeleteSvg } from './../../images/upload_delete.svg';
import { ReactComponent as UploadErrorSvg } from './../../images/upload_error.svg';
import { ReactComponent as UploadBtnIcon } from './../../images/icon_upload-btn.svg';
import { IHooksParams } from './../../type';

const { Option } = Select;

const ModelCondition: React.FC<IHooksParams> = props => {
    const {
        customize,
        currentValue,
        dataFeatureStatus,
        fileList,
        errorFileStatus,
        loadingStatus,
        submitStatus,
        tabsIndex,
        buttonStatus,
        form,
        initialValues,
        handleCheckboxChange,
        setCustomize,
        setButtonStatus,
        setInputValue,
        setTabsIndex,
        onFileListChange,
        handleCustomScene,
        onValuesChange,
        handleFinish,
        normalFile
    } = props;

    const uploadProps = {
        action: '/eda/upload',
        fileList: fileList,
        maxCount: 1,
        multiple: false,
        showUploadList: {
            showRemoveIcon: true,
            removeIcon: <UploadDeleteSvg className="upload-delete-icon" />
        },
        progress: {
            strokeColor: '#2932e1',
            strokeWidth: 5,
            format: (percent: any) => `${parseFloat(percent.toFixed(0))}%`
        },

        iconRender: (UploadFile: any) =>
            !errorFileStatus ? (
                <UploadFileSvg className="upload-file-icon" />
            ) : (
                // <Popover content={UploadFile?.response?.msg ?? '上传失败，请重新上传'}>
                //     <UploadErrorSvg className="upload-file-icon" />
                // </Popover>
                <UploadErrorSvg className="upload-file-icon" />
            ),
        onChange: onFileListChange
    };

    const getImageSize = () => {
        if ([2, 3].includes(tabsIndex)) {
            return {
                width: '509px',
                height: '168px'
            };
        } else if ([4].includes(tabsIndex)) {
            return {
                width: '511px',
                height: '86px'
            };
        } else {
            return {
                width: '513px',
                height: '168px'
            };
        }
    };

    const handleStatementClick = () => {
        Modal.info({
            title: '使用及免责声明',
            okText: '确认',
            className: 'model-condition-statement-wrapper',
            centered: true,
            content: (
                <div className="statement-wrapper">
                    <div className="statement-desc">{statementDesc[1]}</div>
                    {statementDesc.slice(2).map((item, index) => (
                        <div className="state-content-item" key={item}>
                            {index + 1 + '. ' + item}
                        </div>
                    ))}
                </div>
            )
        });
    };

    return (
        <div className="paddle-model-condition">
            <div className="paddle-model-condition-title">{modelParams.title}</div>
            <Form
                colon={false}
                onValuesChange={onValuesChange}
                form={form}
                onFinish={handleFinish}
                initialValues={initialValues}
            >
                {modelParams.selectorList.map((item, pos) => (
                    <div className="paddle-model-condition-content" key={item.title}>
                        <div className="paddle-model-condition-content-title">{item.title}</div>
                        <Row gutter={24}>
                            {item.list.map((element, index) => (
                                <Col span={8} key={element.label}>
                                    <Form.Item
                                        label={
                                            <div
                                                className={classNames('condition-item-label', {
                                                    'short-distance': index === 1
                                                })}
                                            >
                                                {element.label}
                                                {element.tips && (
                                                    <Popover content={element.tips} overlayStyle={{ width: '424px' }}>
                                                        <span className="condition-item-label-tips" />
                                                    </Popover>
                                                )}
                                            </div>
                                        }
                                        name={element.name}
                                        rules={[{ required: element.isRequire, message: '请填写必填项后再提交' }]}
                                    >
                                        <Select
                                            style={{ width: '258px' }}
                                            placeholder={element.placeholder}
                                            size="large"
                                            dropdownClassName="paddle-model-drapdown"
                                            suffixIcon={<span className="paddle-model-condition-custom-icon" />}
                                            clearIcon={<CloseOutlined className="paddle-model-condition-remove-icon" />}
                                            allowClear={!element.isRequire}
                                            onDropdownVisibleChange={open => {
                                                if (open) {
                                                    setCustomize(false);
                                                    setButtonStatus(true);
                                                }
                                            }}
                                            dropdownRender={menu => {
                                                return (
                                                    <>
                                                        {pos === 0 && index === 0 && (
                                                            <div className="custom-content">
                                                                {!customize ? (
                                                                    <div
                                                                        className="custom-content-access"
                                                                        onClick={() => setCustomize(true)}
                                                                    >
                                                                        <span className="custom-content-access-add" />
                                                                        自定义场景
                                                                    </div>
                                                                ) : (
                                                                    <div className="custom-content-input">
                                                                        <Input
                                                                            placeholder="请输入内容"
                                                                            onChange={e => {
                                                                                setButtonStatus(!e.target.value);
                                                                                setInputValue(e.target.value);
                                                                            }}
                                                                            style={{
                                                                                width: '180px',
                                                                                marginRight: '8px',
                                                                                borderRadius: '0'
                                                                            }}
                                                                        />
                                                                        <Button
                                                                            disabled={buttonStatus}
                                                                            onClick={() =>
                                                                                handleCustomScene(item, element)
                                                                            }
                                                                        >
                                                                            确认
                                                                        </Button>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        )}
                                                        {menu}
                                                    </>
                                                );
                                            }}
                                        >
                                            {element.itemList.map(unit => (
                                                <Option
                                                    key={unit.value}
                                                    value={unit.value}
                                                    className={classNames({ 'other-scene': unit.value === 'a3' })}
                                                >
                                                    {unit.lable}
                                                </Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </Col>
                            ))}
                        </Row>
                    </div>
                ))}

                <Row gutter={24}>
                    <Col span={8} className="smrt-upload-item">
                        <Form.Item
                            // label={<div className="condition-item-label">{dataAnalyze.upload.label}</div>}
                            name="file_name"
                            valuePropName="fileList"
                            getValueFromEvent={normalFile}
                            label={
                                <div className="condition-item-label">
                                    {dataAnalyze.upload.label}
                                    {
                                        <Popover
                                            content="为了帮助用户更好的分析数据特点，用户仅需上传标注文件（不需要原图）即可帮助用户进一步分析数据特点并提供优化建议。"
                                            overlayStyle={{ width: '320px' }}
                                            overlayClassName="codition-item-label-tips-wrapper"
                                        >
                                            <span className="condition-item-label-tips" />
                                        </Popover>
                                    }
                                </div>
                            }
                        >
                            <Upload {...uploadProps}>
                                <Button icon={<UploadBtnIcon className="paddle-upload-btn-icon" />} size="large">
                                    {dataAnalyze.upload.btnWord}
                                </Button>
                            </Upload>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item
                            label={
                                <div className="condition-item-label short-distance">
                                    {dataAnalyze.dataFeature.label}
                                </div>
                            }
                            name="g"
                        >
                            <Checkbox.Group onChange={handleCheckboxChange}>
                                <Select
                                    style={{ width: '258px' }}
                                    placeholder={dataAnalyze.dataFeature.placeholder}
                                    size="large"
                                    dropdownClassName="paddle-model-drapdown"
                                    mode="multiple"
                                    showArrow
                                    showSearch={false}
                                    optionLabelProp="value"
                                    maxTagCount={'responsive' as const}
                                    onChange={handleCheckboxChange}
                                    value={currentValue}
                                    suffixIcon={<span className="paddle-model-condition-custom-icon" />}
                                >
                                    {dataAnalyze.dataFeature.list.map((item, index) => (
                                        <Option
                                            value={item.label}
                                            key={item.label}
                                            disabled={
                                                !dataFeatureStatus.isInitial &&
                                                !dataFeatureStatus.isNone.includes(index)
                                            }
                                        >
                                            <div>
                                                <Checkbox
                                                    value={item.label}
                                                    disabled={
                                                        !dataFeatureStatus.isInitial &&
                                                        !dataFeatureStatus.isNone.includes(index)
                                                    }
                                                >
                                                    {item.label}
                                                </Checkbox>
                                            </div>
                                        </Option>
                                    ))}
                                </Select>
                            </Checkbox.Group>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
            <div className="paddle-model-condition-illustrate">
                <span className="illustrate-word">数据集导入规则说明</span>
                <a
                    className="illustrate-document"
                    target="_blank"
                    rel="noreferrer"
                    href="https://github.com/PaddlePaddle/PaddleDetection/blob/release/2.4/configs/smrt/DataAnalysis.md"
                >
                    说明文档
                </a>
            </div>
            <div className="paddle-model-condition-format">
                <div className="paddle-model-condition-format-tabs">
                    {datasetArr.map((item, index) => (
                        <div
                            className={classNames('paddle-model-condition-format-tabs-item', {
                                'is-selected-tabs': tabsIndex === index
                            })}
                            onClick={() => setTabsIndex(index)}
                            key={item.label}
                        >
                            {item.label}
                        </div>
                    ))}
                </div>
                <div className="paddle-model-condition-format-contents">
                    <div className="paddle-model-condition-format-contents-desc">
                        <div className="para-wrapper">
                            {datasetArr[tabsIndex].descArr.map(item => (
                                <>
                                    <div className="desc-para" key={item}>
                                        {item}
                                    </div>
                                    <img
                                        style={getImageSize()}
                                        className="desc-image"
                                        src={datasetArr[tabsIndex].imageUrl}
                                        alt={datasetArr[tabsIndex].label}
                                    />
                                </>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            <div className="paddle-model-condition-statement">
                免责声明：在使用飞桨产业级模型选型工具前，请您务必仔细阅读并理解透彻
                <span className="paddle-model-condition-statement-content" onClick={handleStatementClick}>
                    《免责声明》
                </span>
                {/* </Popover> */}
            </div>
            <div className="paddle-model-condition-create">
                <Popover
                    content="请输入所有必填项后再试"
                    overlayStyle={{ visibility: !submitStatus ? 'visible' : 'hidden' }}
                >
                    <div
                        className={classNames('paddle-model-condition-create-btn', {
                            'is-disabled': !submitStatus
                        })}
                        onClick={() => {
                            if (!submitStatus) {
                                return;
                            }
                            form.submit();
                        }}
                    >
                        生成模型推荐
                    </div>
                </Popover>
            </div>
            {loadingStatus && (
                <div
                    className={classNames('paddle-model-condition-mask', {
                        loadingStatus: 'mask-status'
                    })}
                >
                    <div className="mask-loading">
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                    <div className="mask-loading-text">模型选型结果需要在数分钟内生成，请耐心等待</div>
                </div>
            )}
        </div>
    );
};

export default ModelCondition;
